export const config = {
  env: 'development',
  isDev: true,
  apiURI: 'https://dev.enty.io/api',
  subscribesURI: 'wss://dev.enty.io/api',
  filestorage: 'https://dev-filestorage.enty.io',
  domainUrl: 'https://dev.enty.io',
  // sentryDsn: 'https://07635677a9b040e59e6ecee0f0f70626@o508566.ingest.sentry.io/5601251',
} as const;
